// The derivation itself is shared: the .docx import binds by the same name, so a second copy
// here would silently store links under names the palette never offers.
export { fieldNameFromPath } from '@dealstack/shared/lib/common/business/documentTemplate';

/** Makes `name` unique against names already in the document, so two data points can coexist. */
export const uniqueFieldName = (name: string, taken: ReadonlySet<string>): string => {
	if (!taken.has(name)) {
		return name;
	}
	let suffix = 2;
	while (taken.has(`${name}_${suffix}`)) {
		suffix += 1;
	}
	return `${name}_${suffix}`;
};
